module.exports = "https://static.wagwalking.com/_next/static/images/review3-6f32b6ed20288e69fd44539931ae782d.webp";